module.exports = __webpack_public_path__ + "img/medical-health.7611fe42.svg";